import { BlockedUser, ErrorCodes, GenericError, InvalidCountry, NumberNotWorking, SMSGatewayError, TooManyAttempts, WrongCode, } from '@lendi/lala-utils';
import { AuthTypes } from '../components/ChatComponent/SmartChat/states';
export var matchPatterns;
(function (matchPatterns) {
    matchPatterns["WRONG_CODE"] = "passcode incorrect";
    matchPatterns["TOO_MANY_ATTEMPTS"] = "attempts";
    matchPatterns["BLOCKED_USER"] = "blocked";
    matchPatterns["NUMBER_NOT_WORKING"] = "not working";
    matchPatterns["SMS_GATEWAY_NOT_WORKING"] = "SMS gateway";
    matchPatterns["POPUP_CLOSED"] = "User closed the popup window";
    matchPatterns["INVALID_COUNTRY"] = "non-allowed country";
})(matchPatterns || (matchPatterns = {}));
export var handleAuthError = function (_a) {
    var error = _a.error, authDispatch = _a.authDispatch, onException = _a.onException;
    if (!error) {
        return;
    }
    switch (error.code) {
        case ErrorCodes.ACCESS_DENIED:
            if (error.description.toLowerCase().includes(matchPatterns.WRONG_CODE)) {
                authDispatch({ type: AuthTypes.ERROR, payload: new WrongCode() });
            }
            else if (error.description.toLowerCase().includes(matchPatterns.TOO_MANY_ATTEMPTS)) {
                authDispatch({ type: AuthTypes.ERROR, payload: new TooManyAttempts() });
            }
            break;
        case ErrorCodes.BLOCKED_USER:
            authDispatch({ type: AuthTypes.ERROR, payload: new BlockedUser() });
            break;
        case ErrorCodes.TOO_MANY_ATTEMPTS:
            authDispatch({ type: AuthTypes.ERROR, payload: new TooManyAttempts() });
            break;
        case ErrorCodes.UNAUTHORIZED:
            if (error.description.toLowerCase().includes(matchPatterns.INVALID_COUNTRY)) {
                authDispatch({ type: AuthTypes.ERROR, payload: new InvalidCountry() });
            }
            break;
        case ErrorCodes.SMS_PROVIDER_ERROR:
            if (error.description.toLowerCase().includes(matchPatterns.NUMBER_NOT_WORKING)) {
                authDispatch({ type: AuthTypes.ERROR, payload: new NumberNotWorking() });
            }
            else if (error.description.toLowerCase().includes(matchPatterns.SMS_GATEWAY_NOT_WORKING)) {
                authDispatch({ type: AuthTypes.ERROR, payload: new SMSGatewayError() });
            }
            break;
        case ErrorCodes.NUMBER_NOT_WORKING:
            authDispatch({ type: AuthTypes.ERROR, payload: new NumberNotWorking() });
            break;
        case ErrorCodes.GENERIC:
        case ErrorCodes.PARSE_STATE:
        default:
            authDispatch({ type: AuthTypes.ERROR, payload: new GenericError() });
            break;
    }
    onException(new Error("@lendi/chat: SmartChat: unable to send code: ".concat(error.description)));
};
//# sourceMappingURL=authError.js.map